<div [ngClass]="[('help' + (hasFooter ? '-footer' : '') + '-container')]">
  <iframe id="helpframe"
          [src]="frameUrl"
          frameborder="0"
          width="100%"
          height="100%"
          sandbox="allow-same-origin allow-top-navigation allow-scripts">
  </iframe>
</div>
